import { apiFetch } from '@/lib/http/client';

/** A meeting linked to a document, as `GET …/calendar/events/for-document` lists it. */
export interface LinkedEvent {
  eventId: string;
  title: string;
  startAt: string;
  endAt: string;
  isAllDay: boolean;
  isRecurringSeries: boolean;
  linkedByEditor: boolean;
}

export function fetchDocumentEvents(entityId: string): Promise<LinkedEvent[]> {
  return apiFetch<LinkedEvent[]>(
    `/workspace/integrations/calendar/events/for-document?entityId=${encodeURIComponent(entityId)}`,
  );
}
